import axios from 'axios';
import { store, TOKEN } from '../store';
import { logout } from '../actions/UserActions';
import i18n from '../i18n';

const FRONTEND_VERSION = process.env.REACT_APP_VERSION;

async function request(params, includeToken = true) {
  const url = `/api${params.url}`;
  const token = store[TOKEN].value;

  let headers = {
    Version: FRONTEND_VERSION,
    'X-Client-Language': i18n.language,
  };

  if (includeToken) {
    headers = {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }

  const res = await axios({
    ...params,
    headers: {
      ...headers,
      ...(params.headers || {}),
    },
    url,
  }).catch((e) => {
    if (e?.response?.status === 401) {
      logout();
      if (window.location.pathname !== '/login') {
        window.location = '/login';
      }
    } else if (e?.response?.status === 418) {
      window.location.reload();
    }
    throw e;
  });

  if (res.headers['x-authorization-refresh']) {
    // Auth token has expired but within margin so has been refreshed
    // updating for future api calls
    store[TOKEN].next(res.headers['x-authorization-refresh']);
  }

  return res;
}

export function get(url, { signal, includeToken, ...params } = {}) {
  return request(
    {
      method: 'GET',
      url,
      signal,
      ...params,
    },
    includeToken
  );
}

export function del(url, data = null, { includeToken, ...params } = {}) {
  return request(
    {
      method: 'DELETE',
      url,
      data,
      ...params,
    },
    includeToken
  );
}

export function post(url, data = null, { includeToken, ...params } = {}) {
  return request(
    {
      method: 'POST',
      url,
      data,
      ...params,
    },
    includeToken
  );
}

export function put(url, data = null, { includeToken, ...params } = {}) {
  return request(
    {
      method: 'PUT',
      url,
      data,
      ...params,
    },
    includeToken
  );
}
